<template>
  <el-row>
    <el-col :span="24">
      <h3>User Notifications Based on PEA Status and Division</h3>
      <transition name="panel">
        <div class="pea-panel .rules-panel">
          <el-table :data="notificationListeners" @current-change="selectRow" class="allNotificationsTable" v-loading="tableLoading">
            <el-table-column prop="peaNotificationDescription" align="left"
                             label="Notification Description">
            </el-table-column>
            <el-table-column property="userFullName" align="left"
                             label="User Notified">
            </el-table-column>
            <!--<el-table-column prop="peaNotificationDescription" align="left"
                             label="Notification Description">
            </el-table-column>-->
            <el-table-column prop="divisionName" align="left"
                             label="PEA Division">
            </el-table-column>
            <el-table-column prop="statusName" align="left"
                             label="PEA Status">
            </el-table-column>

          </el-table>
          <el-pagination v-if="resultTotal > pageSize"
                         @current-change="fetchData"
                         :current-page.sync="currentPage"
                         :page-size="pageSize"
                         layout="total, prev, pager, next"
                         :total="resultTotal">
          </el-pagination>
        </div>
      </transition>
    </el-col>
  </el-row>
</template>
<script>
import router from '@/router'
export default {
  name: 'adminPEANotificationListeners',
  data () {
    return {
      notificationListeners: [],
      currentPage: 1,
      pageSize: 15,
      resultTotal: 0,
      tableLoading: true
    }
  },
  methods: {
    fetchData: function () {
      this.tableLoading = true
      var call = '/GetActiveNotificationListenerList/' + '?page=' + this.currentPage + '&pageSize=' + this.pageSize
      this.$axios.get(call).then(response => {
        this.notificationListeners = response.data.results
        this.resultTotal = response.data.totalRecords
        this.tableLoading = false
      }).catch(reject => {
        this.tableLoading = false
        this.tableData = null
        this.resultTotal = 0
      })
    },
    selectRow: function (row) {
      if (this.$store.getters.isAdmin) {
        router.push('changeNotificationListener/' + row.id)
      }
    },
    // spanLogicMethod ({ row, column, rowIndex, columnIndex }) {
    //  if (columnIndex === 2) {
    //    return {
    //      rowspan: 1,
    //      colspan: 2
    //    }
    //  } else {
    //    return {
    //      rowspan: 1,
    //      colspan: 1
    //    }
    //  }
    // },
    startUp () {
      this.fetchData()
    }
  },
  mounted () {
    this.startUp()
  }
}
</script>

<style scoped>
  h4 {
    margin-bottom: 20px;
  }

  .rules-panel {
    padding-bottom: 30px;
  }
</style>
<style>
  .allNotificationsTable tr:hover {
    cursor: pointer;
  }
</style>
